define(function (require) {
    var ko = require("knockout");
    require("bootstrap-select");
    var $ = require("jquery");

    ko.bindingHandlers.scrollTo = {
        update: function (element, valueAccessor, allBindings) {
            var value = valueAccessor();
            var valueUnwrapped = ko.unwrap(value);
            if (valueUnwrapped) {
                $(element).closest(".hide-load").removeClass("hide-load");
                setTimeout(function () {
                    var offset = $(element).offset().top;
                    $("html, body").animate({ scrollTop: offset }, 500);
                }, 10);
            }
        }
    };
});
